<template>
  <div>
    <transition name="modal">
      <div v-if="activeDialog" class="fixed inset-0 p-4 z-[2147483646] flex items-center justify-center font-sans">
      
        <div class="absolute inset-0 transition-opacity bg-black/50" @click="closeDialog"></div>

        <DeactivateAllDialog 
          v-if="activeDialog === 'DEACTIVATE_ALL'"
          @close="closeDialog"
          @submit="submitDialog"
        />

        <ActivateAllDialog 
          v-if="activeDialog === 'ACTIVATE_ALL'"
          :max-products="quotaMaxProducts"
          @close="closeDialog"
          @submit="submitDialog"
        />

        <DeleteCategoryDialog 
          v-if="activeDialog === 'DELETE_CATEGORY'"
          @close="closeDialog"
          @submit="submitDialog"
        />

        <CategoryFormDialog 
          v-if="activeDialog === 'ADD_CATEGORY' || activeDialog === 'EDIT_CATEGORY'"
          :is-edit-mode="activeDialog === 'EDIT_CATEGORY'"
          :initial-name="formName"
          :initial-desc="formDesc"
          :catalog-products="catalogProducts"
          :initial-selected-products="selectedProducts"
          :categories="categories"
          :active-category-id="activeCategoryId"
          @close="closeDialog"
          @submit="payload => submitDialog(activeDialog, payload)"
        />

      </div>
    </transition>
  </div>
</template>

<script>
import DeactivateAllDialog from './dialogs/DeactivateAllDialog.vue';
import ActivateAllDialog from './dialogs/ActivateAllDialog.vue';
import DeleteCategoryDialog from './dialogs/DeleteCategoryDialog.vue';
import CategoryFormDialog from './dialogs/CategoryFormDialog.vue';

export default {
  name: 'ManajemenTokoDialogs',
  components: {
    DeactivateAllDialog,
    ActivateAllDialog,
    DeleteCategoryDialog,
    CategoryFormDialog
  },
  data() {
    return {
      activeDialog: null,
      formName: '',
      formDesc: '',
      catalogProducts: [],
      selectedProducts: [],
      quotaMaxProducts: 25,
      categories: [],
      activeCategoryId: null,
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
    document.body.appendChild(this.$el);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    handleMessage(event) {
      if (event.data && event.data.type === 'KOMSTORE_OPEN_DIALOG') {
        this.openDialog(event.data.dialog, event.data.data);
      } else if (event.data && event.data.type === 'KOMSTORE_CLOSE_DIALOG') {
        this.closeDialog();
      }
    },
    openDialog(dialogType, data) {
      this.activeDialog = dialogType;
      this.formName = '';
      this.formDesc = '';
      this.catalogProducts = [];
      this.selectedProducts = [];
      this.categories = [];
      this.activeCategoryId = null;

      if (data) {
        if (data.newCategoryName) this.formName = data.newCategoryName;
        if (data.newCategoryDesc) this.formDesc = data.newCategoryDesc;
        if (data.filteredCatalogForAdd) this.catalogProducts = data.filteredCatalogForAdd;
        if (data.selectedProducts) this.selectedProducts = data.selectedProducts;
        if (data.maxProducts !== undefined) this.quotaMaxProducts = data.maxProducts;
        if (data.categories) this.categories = data.categories;
        if (data.activeCategoryId !== undefined) this.activeCategoryId = data.activeCategoryId;
      }
    },
    closeDialog() {
      this.activeDialog = null;
    },
    submitDialog(dialogType, payloadData = {}) {
      const payload = {
        type: 'KOMSTORE_DIALOG_SUBMIT',
        dialog: dialogType,
        data: payloadData
      };

      const iframe = document.querySelector('iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(payload, '*');
      }
    }
  }
}
</script>

<style scoped>
.modal-enter-active, 
.modal-leave-active {
  transition: opacity 0.2s ease-out;
}
.modal-enter, 
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active :deep(.dialog-content), 
.modal-leave-active :deep(.dialog-content) {
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
.modal-enter :deep(.dialog-content), 
.modal-leave-to :deep(.dialog-content) {
  transform: scale(0.95) translateY(10px);
}
</style>
